import React, { useEffect, useState } from 'react'
import '../style/blog.css'
import 'react-multi-carousel/lib/styles.css';
import { getCategory } from '../services/CategoryService';
import { CircularProgress } from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import BlogCarousel from './BlogCarousel';
import EmptyComponent from './messages/EmptyComponent';
import { ToastContainer, toast } from 'react-toastify';


export default function CategoryBlogs({categoryForBlogs}){
    const [blogs, setBlogs] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    useEffect(()=>{
      setIsLoading(true)
      console.log(categoryForBlogs)
      getCategory(categoryForBlogs).then(res=>{
        console.log(res)
      setBlogs(res.data)
      setIsLoading(false)
    }).catch(err=>{
      console.log(err)
      setIsLoading(false)
    })
    }, [categoryForBlogs])

    const handleShareToast = (message) =>{
      toast.info(message)
    }
    
    return (
      <div style={{marginTop: '2em'}}>
        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable={false}
          pauseOnHover={false}
          theme="light"
          />
        {isLoading && <CircularProgress />}
        {
          blogs != 0 ? 
          !isLoading &&
          <BlogCarousel blogs={blogs} authorDetailsNeeded={true} handleShareToast={handleShareToast}/>
          : 
            !isLoading &&
            <EmptyComponent message="No blogs to display"/>
        }
    </div>
  )
    
}